// Color SVG IMG: https://codepen.io/sosuke/pen/Pjoqqp
<template>
  <div @click="$emit('click')">
    <template v-if="checked">
      <img src="@/assets/shield-check-filled.svg" width="16" height="16" style="filter: invert(31%) sepia(84%) saturate(2356%) hue-rotate(197deg) brightness(100%) contrast(105%);" />
    </template>
    <template v-else>
      <img src="@/assets/shield-check-outline.svg" width="16" height="16" style="filter: invert(91%) sepia(0%) saturate(67%) hue-rotate(140deg) brightness(94%) contrast(97%);" />
    </template>
  </div>
</template>

<script>
export default {
  name: 'ShieldCheck',
  props: ['checked']
}
</script>
